export default __webpack_public_path__ + "static/media/supportroom-logo.7753697a.svg";